import React, { useEffect, useState, useContext } from 'react'
import PageHeader from '../helper/PageHeader';
import { useHistory, useParams } from 'react-router'
import SimpleTable from '../helper/SimpleTable';
import Loading from '../helper/Loading';
import axios from 'axios';
import { withTranslation } from 'react-i18next';
import {RefundInitiate} from '../helper/Dialogs';
import { authContext } from '../../context/AuthContext';
import { trainingCost } from '../../constants/global'
import moment from 'moment';


const AdminUserPurchase = props => {

    const {t} = props; 
    const tableCells = [
        // { id: 'id', label: 'ID', centered: false },
        { id: 'confirmationNumber', label: t('PurchaseTransactions.Confirmation') , centered: false },
        { id: 'documentNumber', label: t('PurchaseTransactions.Document') , centered: false },
        { id: 'submittedDateFormatted', label: t('PurchaseTransactions.PurchaseDate'), centered: false },
        { id: 'transactionAmount', label: t('PurchaseTransactions.TransactionAmount'), centered: false },
        { id: 'submittedAmount', label: t('PurchaseTransactions.SubmittedAmount'), centered: false },
        { id: 'statusDescription', label: t('PurchaseTransactions.Status'), centered: false },
        { id: 'employerName', label: t('PurchaseTransactions.Employer'), centered: false },
    ];


    const history = useHistory()   
    const params = useParams()
    const context = useContext(authContext)

    const [data, setData] = useState(null);

    const [clickedID, setClickedId] = useState(null);

    const [name, setName] = useState(null)

    const [error, setError] = useState(false)

    const [errorMessage, setErrorMessage] = useState('')

    const [addCredit, setAddCredit] = useState({amount: trainingCost, reason: 'Refunded to Card', transId: '', requestDate: '', transactionAmount: 0, deductCredit: false});

    const current = new Date();
    const date = `${current.getMonth()+1}/${current.getDate()}/${current.getFullYear()}`;
    
    async function getData() {
        
        let res = await axios.get('/api/ipay/transactions/user/'+ params.username, {
        });
        console.log('res.data',res.data);
        res.data.forEach(e => {
            console.log(e.UserGroup);
          e.employerName = e.UserGroup ? e.UserGroup.name : null
            e.submittedDateFormatted = moment(e.submittedDate).format('YYYY-MM-DD hh:mm:ss A')
          console.log(e.employerName);
          e.actionsDisabled = {
            allowRefund: (e.transactionStatus === 0) && ( e.employerName === null)
           }
        });
        setData(res.data);
        console.log('res.data', res.data)

        let res2 = await axios.get('/api/user/' + params.username, {
        })

        setName(res2.data.user.first_name + " " +  res2.data.user.last_name )

        console.log('res', res2)
   
    }

    useEffect(() => {
        
        getData();
    // render only once
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };

    const onRefund = async (id) => {
        const course = data.find(e => e.id === id)
        console.log(course);
        setClickedId(course.id);
        setAddCredit( prev => {return {...prev, transId: course.id }});
        setAddCredit( prev => {return {...prev, requestDate: date }});
        setAddCredit( prev => {return {...prev, transactionAmount: course.transactionAmount }});
        setErrorMessage('')
        setError(false)

        handleClickOpen();        
    }

    const handleReason = (event) => {
        event.persist()
        
        setAddCredit( prev => {return {...prev, reason: event.target.value}})
    }

    const handleAmount = (event) => {
        event.persist()
        console.log('event target',event.target.value);
        console.log(' transactionAmount ', addCredit.transactionAmount );

        if(event.target.value > 0 && event.target.value <= addCredit.transactionAmount){
            setAddCredit( prev => {return {...prev, amount: event.target.value}})
        }
    }

    const deductChecked = (event) => {
        setAddCredit( prev => {return {...prev, deductCredit: event.target.checked  }});
    }

    const handleRefundClick = async () => {
        let byUserName = context.user.username;
        let token = context.accessToken;
      
        let data = {
            amount:parseInt(addCredit.amount),
            notes: addCredit.reason,
            byUsername: byUserName,
            username: params.username,
            originalTransactionID: addCredit.transId,
            deductCredit: addCredit.deductCredit
        }

        console.log('from the user',data);
        try{
            await axios('/api/credit/refund/user/' + params.username, {
                method: 'POST',
                data: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })

            handleClose()
            getData()

        }catch(err){
            console.log('error from here', err.response.statusText)
            setErrorMessage( err.response.statusText)
            setError(true)
        }
        
    }

    const actionButtons = [
        { label: 'Refund', action: onRefund, delete: false, view: "allowRefund" },
    ];

    return (
        <>
            <PageHeader title={ params.username + ' '+ t('PurchaseTransactions.MyPurchaseHistory')} cancel={history.goBack} />
            <>Name: {name}</>
            {data === null ? <Loading /> :
                data.length === 0 ? <h1>{t('PurchaseTransactions.NoDataFound')}</h1> :
                    <>
                        
                        <RefundInitiate 
                        open={open}
                        onClose={handleClose}
                        date = {date}
                        transId = {clickedID}
                        onAmountChange={handleAmount}
                        onReasonChange={handleReason}
                        onRefundClick = {handleRefundClick}
                        presentAmountValue = {addCredit.amount}
                        CheckedValue = {addCredit.deductCredit}
                        onChangeDeductCredit = {deductChecked}
                        mainError = {errorMessage}
                        error = {error}
                        />
                        <SimpleTable
                            data={data}
                            cellKey={"id"}
                            tableCells={tableCells}
                            actionButtons={actionButtons}
                            actions={true}
                        />
                    </>
            }

        </>
    )
}

export default withTranslation()(AdminUserPurchase);